<template>
    <div class="ad-details-page">
        <div class="ad-details-container">
            <div id="toPrint" class="ad-details-to-print">
                <div class="time-line-bar">
                    <router-link :to="{ name: 'AdList' }">Achat</router-link>
                    <router-link :to="{ name: 'AdList', params: { type: this.$options.filters.camelCase(ad.d_type) } }">
                        {{ ad.d_type }}
                    </router-link>
                    <p>Réf.{{ ad.d_reference }}</p>
                </div>
                <div class="ad-details-title">
                    <div>
                        <h3>{{ ad.d_type }}</h3>
                        <h3>{{ ad.d_titre }}</h3>
                    </div>
                    <div>
                        <h4>Réf : {{ ad.d_reference }}</h4>
                        <h3>{{ parseInt(ad.d_prix).toLocaleString('fr-FR') }} € FAI</h3>
                    </div>
                </div>
                <bien-photos-gallery :photos="photos"></bien-photos-gallery>
                <div class="ad-details-content">
                    <div class="ad-details-picto-container">
                        <div v-if="ad.d_type !== ''">
                            <img src="../../assets/icons/ad-picto-type.png" alt="picto maison" />
                            <p>{{ ad.d_type }}</p>
                        </div>
                        <div v-if="ad.d_nbrPieces !== ''">
                            <img src="../../assets/icons/ad-picto-room.png" alt="picto pièces" />
                            <p>{{ ad.d_nbrPieces }} pièces</p>
                        </div>
                        <div v-if="ad.d_nbrChambres !== '' && ad.d_nbrChambres > 0">
                            <img src="../../assets/icons/ad-picto-bedroom.png" alt="picto chambres" />
                            <p>{{ ad.d_nbrChambres }} chambres</p>
                        </div>
                        <div v-if="ad.d_surface !== ''">
                            <img src="../../assets/icons/ad-picto-surface.png" alt="picto surface" />
                            <p>Surface {{ ad.d_surface }}</p>
                        </div>
                        <div v-if="ad.d_surfaceTerrain !== ''">
                            <img src="../../assets/icons/ad-picto-terrain.png" alt="picto surface terrain" />
                            <p>Terrain {{ ad.d_surfaceTerrain }}</p>
                        </div>
                    </div>
                    <div>
                        <h4>Description du bien</h4>
                        <p v-html="ad.d_descriptif"></p>
                    </div>
                    <DPE :bien="ad"></DPE>
                    <div>
                        <h4 v-if="ad.d_descriptifComp !== ''">Informations complémentaires</h4>
                        <p v-html="ad.d_descriptifComp"></p>
                    </div>
                </div>
            </div>
            <div class="ad-details-sidebar">
                <div class="ad-details-contact-container">
                    <div class="ad-details-contact-title">Cette offre m'intéresse</div>
                    <div v-if="formSent" v-html="'Le formulaire a bien été envoyé.'"></div>
                    <form v-else class="ad-details-contact-form" @submit.stop.prevent="sendInterest">
                        <input id="name" v-model="contactInfo.nom" placeholder="Votre nom/prénom" required/>
                        <input id="email" type="email" v-model="contactInfo.email" placeholder="Votre email" required/>
                        <input id="phone" type="phone" v-model="contactInfo.telephone" placeholder="Votre téléphone (optionnel)" />
                        <input id="comment" v-model="contactInfo.questions" placeholder="Commentaire" />
                        <input type="submit" class="submit" value="Envoyez ma demande" />
                    </form>
                    <div class="ad-details-contact-data" v-if="societe">
                        <a>
                            <img src="../../assets/icons/icn-phone.svg" />
                            <div>
                                <p>Appelez-nous</p>
                                <p v-html="societe ? societe.d_telSociete : ''"></p>
                            </div>
                        </a>
                        <a>
                            <img src="../../assets/icons/icn-phone.svg" />
                            <div>
                                <p>Constactez-nous par email</p>
                                <p v-html="societe ? societe.d_adresseContact : ''"></p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="ad-details-contact-simulator-container">
                    <Simulateur>
                    </Simulateur>
                </div>
            </div>

        </div>
        <div v-if="Object.entries(adsAnnexes).length > 0" class="ad-annexe-wrapper">
            <div class="ad-annexe-container">
                <h4>A découvrir également</h4>
                <div class="ad-annexe-list">
                    <ad-preview v-for="(ad, idx) in adsAnnexes" :key="idx" :ad="ad"></ad-preview>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { ButtonPlugin, ModalPlugin } from 'bootstrap-vue'
import { getImage } from '../../mixins/getImage'
import DPE from '../../components/DPE.vue'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
    name: 'AdDetails',
    components: {
        Simulateur: () => import("../../components/Simulateur"),
        PictoArrow: () => import("../../components/PictoArrow"),
        PictoNetwork: () => import("../../components/PictoNetwork"),
        PictoPrint: () => import("../../components/PictoPrint"),
        AdPreview: () => import("./AdPreviewCard.vue"),
        BienPhotosGallery: () => import("../../components/BienPhotosGallery.vue"),
        BienAlertEmail: () => import("../../components/BienAlertEmail.vue"),
        DPE
    },
    mixins: [getImage],
    data() {
        return {
            ad: {
                d_type: null,
                d_reference: null,
                d_price: null,
                d_titre: null,
                d_nbrPieces: null,
                d_surface: null,
                d_descriptif: null
            },
            d_image: '',
            photos: [],
            adsAnnexes: {},
            societe: null,
            contactInfo: {
                nom: '',
                email: '',
                telephone: '',
                questions: '',
                type: 'interet',
                destinataire: 'ti'
            },
            formSent: false
        }
    },
    props: {
        recordId: String
    },
    methods: {
        async loadBien() {
            const options = {
                apiUrl: this.$apiUrl,
                databaseName: this.$databaseName,
                token: await this.$getMainToken()
            }
            const dataApi = new DataApi(options)
            dataApi.getRecord('W_AnnonceDetail', this.recordId, [{ name: 'photos' }])
                .then((response) => {
                    this.ad = response[0].fieldData
                    const adPhotosL = JSON.parse(JSON.stringify(response[0].portalData[Object.keys(response[0].portalData)]))
                    console.log(adPhotosL.length)
                    if (adPhotosL.length > 0) {
                        this.insertBienPhotos(adPhotosL)
                    }
                    const query = this.buildRequest()
                    const sort = [
                        {
                            fieldName: 'd_prix',
                            sortOrder: 'descend'
                        },
                        {
                            fieldName: 'd_dateAnnonce',
                            sortOrder: 'descend'
                        }
                    ]
                    dataApi.findRecords('W_Annonce', query, sort, '', '3')
                        .then((response) => {
                            this.insertBiensAnnexes(response)
                        })
                })
        },
        buildRequest() {
            const nbrPieces = parseInt(this.ad.d_nbrPieces * 0.8)
            const surface = parseInt(this.ad.d_surface * 0.8)
            const budget = parseInt(this.ad.d_prix * 0.8)
            const arrayFields = [
                { fieldname: 'd_type', fieldvalue: `==${this.ad.d_type}` },
                { fieldname: 'd_nbrPieces', fieldvalue: `>=${nbrPieces}` },
                { fieldname: 'd_surface', fieldvalue: `>=${surface}` },
                { fieldname: 'd_prix', fieldvalue: `>=${budget}` }
            ]
            const query = []
            query.push({ fields: arrayFields })
            return query
        },
        insertBienPhotos(adPhotosL) {
            this.photos = []
            adPhotosL.forEach(function (value, index) {
                const photo = Vue.removeLayout(value)
                this.getImage(photo.recordId)
                    .then(res => {
                        const ph = {}
                        ph.d_image = res
                        ph.d_imageAlt = photo.d_imageAlt
                        this.photos.push(ph)
                    })
            }, this)
        },
        insertBiensAnnexes(adsAnnexesL) {
            const adsAnnexesList = (adsAnnexesL === undefined) ? [] : adsAnnexesL
            if (adsAnnexesList.length > 0) {
                const adsToInsert = {}
                adsAnnexesList.forEach(function (value, index) {
                    const dataToInsert = value.fieldData
                    dataToInsert.recordId = value.recordId
                    adsToInsert[index] = dataToInsert
                })
                this.adsAnnexes = adsToInsert
            } else {
                this.adsAnnexes = {}
            }
        },
        imprimer() {
            window.print()
        },
        async sendInterest () {
            console.log('send')
            const demandeToSend = this.contactInfo
            demandeToSend.reference = this.ad.d_reference
            console.log(demandeToSend)
            const options = {
                apiUrl: this.$apiUrl,
                databaseName: this.$databaseName,
                token: await this.$getMainToken()
            }
            this.dataApi = new DataApi(options)
            this.dataApi.createRecord(
                'W_DemandeContact', 
                demandeToSend
            )
            .then((res) => {
                this.formSent = true
            })
        }
    },
    watch: {
        // call the method if the route changes
        $route: {
            handler: 'loadBien',
            immediate: true // runs immediately with mount() instead of calling method on mount hook
        }
    },
    async beforeMount() {
        const options = {
            apiUrl: this.$apiUrl,
            databaseName: this.$databaseName,
            token: await this.$getMainToken()
        }
        this.dataApi = new DataApi(options)
        this.dataApi.findRecords('W_Societe', { 'd_codeSociete': 'ti' }, '', '', '')
        .then((response) => {
            this.societe = response[0] ? response[0]['fieldData'] : null
        })
    }
}
</script>
  
<style lang="scss">
.ad-details-page {
    background-color: var(--color-background-light-grey);
    width: 100%;

    h4 {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

.ad-details-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.ad-details-to-print {
    max-width: 800px;
    width: 100%;
}

.time-line-bar {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: var(--font-size-small);
    margin: 16px;

    a {
        color: var(--color-primary);

        &::after {
            content: '>';
            padding: 0 0.5rem !important;
            color: black;
        }
    }

    p {
        color: black;
        margin: 0;
    }
}

.ad-details-title {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    margin: 16px;
    justify-content: space-between;

    &>div {
        display: flex;
        flex-direction: column;
    }
}

.ad-details-content {
    border-radius: 4px;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    padding: 24px 48px;
    margin: 16px 0;
}

.ad-details-picto-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 16px;
        width: 65px;

        p {
            margin: 1rem 0;
            text-align: center;
        }
    }
}

.ad-details-sidebar {
    max-width: 332px;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    height: fit-content;
    margin-top: 114px;

    &>div {
        background-color: white;
        border-radius: 4px;
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
    }
}

.ad-details-contact-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;

    .ad-details-contact-title {
        width: 100%;
        background-color: black;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 84px;
        font-size: 1.3rem;
        font-weight: 700;
        border-radius: 4px 4px 0 0;
        padding: 24px;
    }

    .ad-details-contact-form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 24px;
        width: 100%;

        .submit {
            background-color: var(--color-primary);
            color: white;
            height: 50px;
            width: 100%;
            border: none;
            border-radius: 5px;
        }

        input {
            border: none;
            border-bottom: solid 1px #ddd;
            margin: 4px 10px 4px 10px;
            height: 46px;
            display: block;
            width: 100%;
        }
    }
}

.ad-annexe-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding: 64px 24px;

    .ad-annexe-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .ad-annexe-list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
}

.mainPicture {
    display: block !important;
    height: 35rem !important;
}

.articlePictures {
    height: 16vh;
    max-height: 11rem !important;
}

.infosLogo {
    li {
        display: flex !important;
        flex-direction: column;
        width: 19% !important;

        img {
            width: 5.4rem !important;
            height: 5.7rem !important;
            margin: 0 auto;
        }

        p {
            text-align: center;
            padding: 0 0.5rem;
            width: 100%;
        }
    }
}

.ad {
    img {
        width: 100% !important;
        height: 15rem !important;
    }
}

.calculate-card {
    height: 23rem !important;

    img {
        display: block;
        width: 4rem !important;
        height: 6rem !important;
    }
}

.prix {
    height: 3rem !important;
}

.picture {
    height: 11rem !important;
}

@media (min-width: 576px) {
    .ad {
        max-width: 30rem !important;
        width: 30% !important;
    }
}

.bandeau {
    transform: rotate(45deg);
}

.bandeau.sousOffre {
    top: 2rem;
    right: -2rem;
}

.bandeau.sousCompromis {
    top: 3rem;
    right: -2rem;
}

.bandeau.vendu {
    top: 0.8rem;
    right: -2rem;
}

.bandeau::after {
    padding: 0rem 2rem !important;
}

.bandeau.sousOffre::after {
    content: 'Sous offre';
    background-color: yellow;
    color: black !important;
}

.bandeau.sousCompromis::after {
    content: 'Sous compromis';
    background-color: orange;
    color: white !important;
}

.bandeau.vendu::after {
    content: 'Vendu';
    background-color: red;
    color: white !important;
}

@media (max-width: 489px) {
    #timeLineBar {

        li:nth-of-type(1):after,
        li:nth-of-type(2):after {
            padding: 0 0.2rem !important;
        }

        button {
            width: 6rem !important;
        }
    }

    .infosLogo {
        li {
            img {
                width: 3.4rem !important;
                height: 3.7rem !important;
            }

            p {
                padding: 0 !important;
            }
        }
    }
}

.bgGreyPoints {
    background: url('../../assets/images/effet-points-3colonnes.svg') no-repeat right bottom;
    background-size: 100%;

    #buttonBar {

        button,
        a {
            ::v-deep .pictoArrow {
                fill: var(--secondary);
                height: 0.65rem;
            }

            ::v-deep .pictoAlert,
            ::v-deep .pictoPrint,
            ::v-deep .pictoNetwork {
                stroke: var(--secondary);
            }
        }

        button:hover,
        a:hover {
            ::v-deep .pictoArrow {
                fill: var(--light);
            }

            ::v-deep .pictoAlert,
            ::v-deep .pictoPrint,
            ::v-deep .pictoNetwork {
                stroke: var(--light);
            }
        }
    }
}

@media print {

    #timeLineBar,
    .bgGreyPoints,
    .btn {
        display: none !important;
    }

    #toPrint {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        padding-bottom: 350px;
    }
}
</style>
  